import service from "@irati-tracking/tracker"
import {
  BannerDismissedParams,
  BannerButtonParams,
  modalButtonParams,
  modalLinkParams,
  CategorySelectionParams,
  CategorySaveParams,
  CategoryResetParams,
  CategoryAbandonedParams,
  PerksHomepageCategoryClickedParams,
  PerksHomepageEditClickedParams,
  PerksHomepageSeeMoreParams,
  PerksHomepageSelectedCategoryWithNoDealsParams,
  PerksHomepageNoDealsLinkClickedParams,
  PerksHomepageCategoryRemovedModalDismissedParams,
  PerksHomepageCategoryRemovedModalNavigateParams,
  CategoryRemovedModalDismissedParams
} from "./interfaces"

const TRACKING_ROOT = "user_onboarding_"

class UserOnboardingTracking {
  welcomePopUpDismissed = () => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}welcome_popup_dismissed`, {})
  }
  welcomePopUpGoToProfile = () => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}welcome_popup_go_to_profile`, {})
  }
  bannerDismissed = (params: BannerDismissedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}banner_dismissed`, params)
  }
  bannerButtonClicked = (params: BannerButtonParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}banner_button_clicked`, params)
  }
  modalButtonClicked = (params: modalButtonParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}modal_button_clicked`, params)
  }
  modalLinkClicked = (params: modalLinkParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}modal_link_clicked`, params)
  }
  categorySelected = (params: CategorySelectionParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}category_selected`, params)
  }
  categoryDeselected = (params: CategorySelectionParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}category_deselected`, params)
  }
  categoriesSaved = (params: CategorySaveParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}categories_saved`, params)
  }
  categoriesReset = (params: CategoryResetParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}categories_clearall`, params)
  }
  categoryChangesAbandoned = (params: CategoryAbandonedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}category_changes_abandoned`, params)
  }
  perksHomepageCategoryClicked = (params: PerksHomepageCategoryClickedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_category_clicked`, params)
  }
  perksHomepageEditClicked = (params: PerksHomepageEditClickedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_edit_clicked`, params)
  }
  perksHomepageSeeMoreClicked = (params: PerksHomepageSeeMoreParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_seemore_clicked`, params)
  }
  perksHomepageSelectedCategoryWithNoDeals = (params: PerksHomepageSelectedCategoryWithNoDealsParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_selected_category_nodeals`, params)
  }
  perksHomepageNoDealsLinkClicked = (params: PerksHomepageNoDealsLinkClickedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_nodeals_link_clicked`, params)
  }
  perksHomepageCategoryRemovedModalDismissed = (params: PerksHomepageCategoryRemovedModalDismissedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_category_removed_modal_dismissed`, params)
  }
  perksHomepageCategoryRemovedModalNavigate = (params: PerksHomepageCategoryRemovedModalNavigateParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}perks_homepage_category_removed_modal_navigate`, params)
  }
  categoryRemovedModalDismissed = (params: CategoryRemovedModalDismissedParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}category_removed_modal_dismissed`, params)
  }
}

const userOnboardingTracking = new UserOnboardingTracking()

export default userOnboardingTracking
